import type { PreviewEmail, PreviewNotificada } from "../types/preview";
import { isValidCnpj } from "./validators";

export interface LocalRegistryEntry {
  razaoSocial: string;
  cnpj: string | null;
  emails: string[];
  sede?: string;
}

export const CNPJ_A_CONFIRMAR = "CNPJ a confirmar";

export const isEntryVerified = (entry?: LocalRegistryEntry): boolean => Boolean(entry?.cnpj && isValidCnpj(entry.cnpj));

export function notificadaFromEntry(entry: LocalRegistryEntry, enderecamento: string): PreviewNotificada {
  const ok = isEntryVerified(entry);
  return { razaoSocial: entry.razaoSocial, cnpj: ok && entry.cnpj ? entry.cnpj : CNPJ_A_CONFIRMAR, verificado: ok, enderecamento, sede: entry.sede ?? null };
}

export const entryEmails = (entry?: LocalRegistryEntry): PreviewEmail[] =>
  (entry?.emails ?? []).map((email) => ({ email, verificado: isEntryVerified(entry) }));

export const verifiedChannelsText = (emails: PreviewEmail[]): string =>
  emails.filter((e) => e.verificado).map((e) => e.email.trim()).join(", ");
